import * as config from '../lib';

export class GlobalComponentConfig {
  static dataConfig: typeof config = config;
}
